import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@/App';

export default function AdminRoute({ children, allowSales = false, allowAgent = false }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="min-h-screen bg-mlt-off-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mlt-orange mx-auto mb-4"></div>
          <p className="text-mlt-text-secondary">Verifying access...</p>
        </div>
      </div>
    );
  }

  // Check if user has appropriate role
  const isAdmin = user?.role === 'admin';
  const isSales = user?.role === 'sales';
  const isAgent = user?.role === 'agent';
  
  // If not logged in, redirect to admin login
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Admin can access everything
  if (isAdmin) {
    return children;
  }

  // Agents can only access routes explicitly marked for agent access.
  if (isAgent && allowAgent) {
    return children;
  }
  
  // Sales users can only access if allowSales is true
  if (isSales && allowSales) {
    return children;
  }
  
  // Otherwise redirect to admin login
  return <Navigate to="/admin/login" replace />;
}
